import React from 'react'

const ContainerError = () => <div>Something happened! Please try again...</div>

export default ContainerError
